import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { Toaster } from 'sonner';
import { setTenantId as saveTenantId } from '../lib/tenant-utils';
import { LanguageProvider } from '../contexts/LanguageContext';
import { AuthProvider } from '../lib/auth-context';

export function RootLayout() {
  useEffect(() => {
    console.log('[RootLayout] Running initialization...');
    
    const existingTenantId = localStorage.getItem('tenantId');
    
    if (!existingTenantId) {
      console.log('[RootLayout] No tenantId found, setting default demo tenant');
      saveTenantId('demo');
    } else {
      console.log(`[RootLayout] TenantId already set: ${existingTenantId}`);
    }
    
    return () => console.log('[RootLayout] Cleanup');
  }, []);

  try {
    console.log('[RootLayout] Rendering providers...');
    
    return (
      <AuthProvider>
        <LanguageProvider>
          <div style={{ minHeight: '100vh', backgroundColor: '#fafafa' }}>
            <Outlet />
          </div>
          <Toaster position="top-right" />
        </LanguageProvider>
      </AuthProvider>
    );
  } catch (error) {
    console.error('[RootLayout] ERROR IN RENDER:', error);
    return (
      <div style={{ padding: '40px', color: 'red' }}>
        <h1>RootLayout Error!</h1>
        <pre>{String(error)}</pre>
      </div>
    );
  }
}